/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_None4Inputs */

const en_job_form_enum_none4 = /** @type {(inputs: Job_Form_Enum_None4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const de_job_form_enum_none4 = /** @type {(inputs: Job_Form_Enum_None4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Job_Form_Enum_None4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_none4 = /** @type {((inputs?: Job_Form_Enum_None4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_None4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_none4(inputs)
	return en_job_form_enum_none4(inputs)
});
export { job_form_enum_none4 as "job_form_enum_NONE" }